module.exports = __webpack_public_path__ + "media/images/brussels/offers/digital-voucher-app-d4fed7680ee63154d60e32a41b52d70d.jpg";